var React = require('react');

function PLAYHEADLG (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_560","data-name":"Group 560","transform":"translate(0.25 0.25)"},[React.createElement("path",{"id":"Path_551","data-name":"Path 551","d":"M24.936,0A24.936,24.936,0,1,1,0,24.936,24.936,24.936,0,0,1,24.936,0Z","fill":"#f40","stroke":"#000","strokeWidth":"0.5","key":0}),React.createElement("path",{"id":"Path_309","data-name":"Path 309","d":"M574.7,892.521v24.51c0,.711,1.122,1.068,1.778.564l16-12.255a.673.673,0,0,0,0-1.128l-16-12.256C575.821,891.455,574.7,891.811,574.7,892.521Z","transform":"translate(-556.067 -879.841)","fill":"#fff","stroke":"#000","strokeMiterlimit":"10","strokeWidth":"1","key":1})]));
}

PLAYHEADLG.defaultProps = {"width":"50.371","height":"50.371","viewBox":"0 0 50.371 50.371"};

module.exports = PLAYHEADLG;

PLAYHEADLG.default = PLAYHEADLG;
